import * as api from '@/api/history';
import showToast from '@jpi-cloud-web-pro/jpi-cloud-shared/components/Notification';
import { getValueFromLocalStorage, setValueInLocalStorage } from '@jpi-cloud-web-pro/jpi-cloud-shared/services/storage';

export const getSingleHistoryChartData = () => {
  const allCharts = getValueFromLocalStorage('HISTORY_CHART_STORE');
  return allCharts;
};

export const setSingleHistoryChartData = charts => {
  setValueInLocalStorage('HISTORY_CHART_STORE', charts);
};

export const getSingleHistoryChartDataPoints = () => {
  const allCharts = getValueFromLocalStorage('HISTORY_CHART_DATA_POINTS');
  return allCharts;
};

export const setSingleHistoryChartDataPoints = charts => {
  setValueInLocalStorage('HISTORY_CHART_DATA_POINTS', charts);
};

export const getChartDataPoints = async ({
  servicePartnerId,
  dateFrom,
  dateTo,
  deviceId,
  parameterId,
  historyId,
  isEnumParameter = false,
  messages,
  setChartDataPoints,
}: {
  servicePartnerId: string | number;
  dateFrom: Date;
  dateTo: Date;
  deviceId: string;
  parameterId: string;
  historyId: string;
  isEnumParameter?: boolean;
  messages?: any;
  setChartDataPoints: (charts: any) => void;
}) => {
  try {
    const response = await api.getHistoryPoints(
      servicePartnerId,
      deviceId,
      parameterId,
      dateFrom.toISOString(),
      dateTo.toISOString(),
      'average',
      'none',
      isEnumParameter,
    );

    setChartDataPoints(prev => ({
      ...prev,
      [historyId]: {
        dataPoints: prev[historyId]?.dataPoints
          ? [...prev[historyId].dataPoints, { parameterId, points: [...response.data.dataPoints] }]
          : [{ parameterId, points: [...response.data.dataPoints] }],
      },
    }));
  } catch (err) {
    showToast('error', messages.error);
  }
};

export const removeSingleHistoryChart = (id: string) => {
  const filteredCharts = getSingleHistoryChartData().filter(chart => chart.historyId !== id);
  const dataPoints = getSingleHistoryChartDataPoints();
  const { [id]: removedChartData, ...updatedDataPoints } = dataPoints;
  setSingleHistoryChartData(filteredCharts);
  setSingleHistoryChartDataPoints(updatedDataPoints);
};

export const clearSingleHistoryChartData = () => {
  setSingleHistoryChartData([]);
  setSingleHistoryChartDataPoints({});
};
